import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

import { setAlert } from "../../../redux/actions/actions";
import { formatErrorResponse } from "../../../utils/stringUtils";
import { createFirmware } from "../../../apiCalls/config/firmware";
import { FirmwareType, fwTypeMap } from "../typings";
import { defaultFirmware } from "../Firmware";
import DeviceFirmwareDetails from "../device-firmware-details/DeviceFirmwareDetails";

const CreateFirmwarePage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const goBack = () => {
    history.push("/config/devices/firmware");
  };

  const handleCreate = async (newFirmware: FirmwareType) => {
    setLoading(true);
    const res = await createFirmware({
      ...newFirmware,
      contentsBase64: newFirmware?.contentsBase64?.split("base64,")?.pop(),
      firmwareType: fwTypeMap[newFirmware.firmwareType],
    });
    setLoading(false);
    if (res?.data) {
      dispatch(setAlert(`Firmware ${newFirmware?.version} created`, "success"));
      goBack();
    } else {
      dispatch(setAlert(formatErrorResponse(res), "error"));
    }
  };

  return (
    <DeviceFirmwareDetails
      initialFirmware={defaultFirmware}
      title="Create Firmware"
      isLoading={loading}
      handleSave={handleCreate}
      handleCancel={goBack}
      isCreating={true}
    />
  );
};

export default CreateFirmwarePage;
